export interface TopNavDocumentData {
  data: {
    contact_us_title: string
    contact_us_subtitle: string
    contactus_description: string
    contact_us_link_text: string
    contact_us_image: {
      dimensions: {
        width: number
        height: number
      }
      alt: string
      url: string
    }
    contact_us_link: string
  }
}

export const topNavData: TopNavDocumentData = {
  data: {
    contact_us_title: 'Talk to sales',
    contact_us_subtitle: 'Get a personalized demo',
    contactus_description:
      'See the full power of the Flowcode platform, and how it help you grow your business.',
    contact_us_link_text: "Let's chat",
    contact_us_image: {
      dimensions: {
        width: 698,
        height: 400
      },
      alt: 'Talk to sales',
      url: '/graphics/locg/Rectangle32.png'
    },
    contact_us_link: 'https://www.flowcode.com/contact-us'
  }
}

export interface TopNavSlice {
  primary: {
    header: string
    header_link?: string
  }
  items: {
    link_title: string
    link_subtext: string
    dropdown_link: string
    subsection?: string
    badge?: string | null
  }[]
}

export const TOP_NAV_DESKTOP_LINKS: TopNavSlice[] = [
  {
    primary: {
      header: 'Features'
    },
    items: [
      {
        link_title: 'Flowcode',
        link_subtext: 'Free QR code generator',
        dropdown_link: 'https://app.flowcode.com/free-qr-code-generator',
        subsection: 'Convert',
        badge: null
      },
      {
        link_title: 'Landing Pages',
        link_subtext: 'Mobile-optimized landing pages designed to convert customers.',
        dropdown_link: 'https://www.flowcode.com/product/landing-pages',
        subsection: 'Convert',
        badge: null
      },
      {
        link_title: 'Analytics',
        link_subtext: 'Real-time data and ROI metrics on your real world activity.',
        dropdown_link: 'https://www.flowcode.com/product/analytics',
        subsection: 'Report',
        badge: null
      },
      {
        link_title: 'Audience Insights',
        link_subtext: 'Monitor customer conversion history across offline touchpoints.',
        dropdown_link: 'https://www.flowcode.com/product/audience-insights',
        subsection: 'Report',
        badge: 'Enterprise'
      },
      {
        link_title: 'Flowcode API',
        link_subtext: 'Connect your tech stack to automate your workflows.',
        dropdown_link: 'https://www.flowcode.com/product/api ',
        subsection: 'Report',
        badge: 'Enterprise'
      },
      {
        link_title: 'Workspaces',
        link_subtext: 'Set team permissions and manage assets for your organization.',
        dropdown_link: 'https://www.flowcode.com/product/workspaces',
        subsection: 'Manage',
        badge: 'Enterprise'
      },
      {
        link_title: 'Integrations',
        link_subtext: 'Connect Flowcode data to your favorite tools.',
        dropdown_link: 'https://www.flowcode.com/features/integrations',
        subsection: 'Manage',
        badge: null
      }
    ]
  },
  {
    primary: {
      header: 'Solutions'
    },
    items: [
      {
        link_title: 'Media and Advertising',
        link_subtext: 'Access omnichannel marketing tools that deliver real-time 1st party data.',
        dropdown_link: 'https://www.flowcode.com/industries/media-and-advertising',
        subsection: 'By industry',
        badge: null
      },
      {
        link_title: 'Sports',
        link_subtext: 'Create seamless fan activations in-stadium and on-screen.',
        dropdown_link: 'https://www.flowcode.com/industries/sports',
        subsection: 'By industry',
        badge: null
      },
      {
        link_title: 'Events',
        link_subtext: 'Instantly connect with audiences at scale and collect insights.',
        dropdown_link: 'https://www.flowcode.com/industries/live-music-events-venues',
        subsection: 'By industry',
        badge: 'Enterprise'
      },
      {
        link_title: 'Purchases and Transactions',
        link_subtext: 'Optimize your media based on real-time insights.',
        dropdown_link: 'https://www.flowcode.com/use-case/purchases-and-transactions',
        subsection: 'By use case',
        badge: null
      },
      {
        link_title: 'Promote Offers and Discounts',
        link_subtext: 'Collect, analyze, and utilize customer data.',
        dropdown_link: 'https://www.flowcode.com/use-case/loyalty-promotions-offer-discounts',
        subsection: 'By use case',
        badge: null
      },
      {
        link_title: 'Personalized experiences',
        link_subtext: 'Bridge the gap between physical intent and digital engagement.',
        dropdown_link: 'https://www.flowcode.com/use-case/personalized-and-interactive-experiences',
        subsection: 'By use case',
        badge: null
      }
    ]
  },
  {
    primary: {
      header: 'Resources'
    },
    items: [
      {
        link_title: 'Blog',
        link_subtext: 'Tips and tricks for growing your business.',
        dropdown_link: 'https://www.flowcode.com/resources/blog',
        subsection: 'Learn',
        badge: null
      },
      {
        link_title: 'Flowcode 1 Help',
        link_subtext: 'Support for Flowcode 1, our classic QR code manager.',
        dropdown_link: 'https://help.flowcode.com/en/',
        subsection: 'Support',
        badge: null
      },
      {
        link_title: 'Flowcode 2 Help',
        link_subtext: 'Support for Flowcode 2, our enterprise conversion platform.',
        dropdown_link: 'https://help.flowcode.com/enterprise/en/',
        subsection: 'Support',
        badge: null
      },
      {
        link_title: 'Careers',
        link_subtext: "We're looking for bar-raisers. Ready to join us?",
        dropdown_link: 'https://www.flowcode.com/company/careers',
        subsection: 'Connect',
        badge: null
      },
      {
        link_title: 'Our team',
        link_subtext: 'The team is the product. The product is the team.',
        dropdown_link: 'https://www.flowcode.com/company/team',
        subsection: 'Connect',
        badge: null
      }
    ]
  },
  {
    primary: {
      header: 'Pricing',
      header_link: 'https://www.flowcode.com/enterprise-pricing'
    },
    items: []
  }
]

export const TOP_NAV_MOBILE_LINKS: TopNavSlice[] = [
  {
    primary: {
      header: 'Features'
    },
    items: [
      {
        link_title: 'Flowcode',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/free-qr-code-generator',
        subsection: 'Convert',
        badge: null
      },
      {
        link_title: 'Landing Pages',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/product/landing-pages',
        subsection: 'Convert',
        badge: null
      },
      {
        link_title: 'Analytics',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/features/analytics',
        subsection: 'Report',
        badge: null
      },
      {
        link_title: 'Audience Insights',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/product/audience-insights',
        subsection: 'Report',
        badge: null
      },
      {
        link_title: 'Flowcode API',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/developer-portal',
        subsection: 'Report',
        badge: null
      },
      {
        link_title: 'Workspaces',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/product/workspaces',
        subsection: 'Manage',
        badge: 'Enterprise'
      },
      {
        link_title: 'Integrations',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/features/integrations',
        subsection: 'Manage',
        badge: null
      }
    ]
  },
  {
    primary: {
      header: 'Solutions'
    },
    items: [
      {
        link_title: 'Media and Advertising',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/industries/media-and-advertising',
        subsection: 'By Industry',
        badge: null
      },
      {
        link_title: 'Sports',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/industries/sports',
        subsection: 'By Industry',
        badge: null
      },
      {
        link_title: 'Events',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/industries/live-music-events-venues',
        subsection: 'By Industry',
        badge: 'Enterprise'
      },
      {
        link_title: 'Purchases and Transactions',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/use-case/purchases-and-transactions',
        subsection: 'By use case',
        badge: null
      },
      {
        link_title: 'Promote Offers and Discounts',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/use-case/loyalty-promotions-offer-discounts',
        subsection: 'By use case',
        badge: null
      },
      {
        link_title: 'Personalized experiences',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/use-case/personalized-and-interactive-experiences',
        subsection: 'By use case',
        badge: null
      }
    ]
  },
  {
    primary: {
      header: 'Resources'
    },
    items: [
      {
        link_title: 'Blog',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/blog',
        subsection: 'Learn',
        badge: null
      },
      {
        link_title: 'Flowcode 1 Help',
        link_subtext: '',
        dropdown_link: 'https://help.flowcode.com/en/',
        subsection: 'Support',
        badge: null
      },
      {
        link_title: 'Flowcode 2 Help',
        link_subtext: '',
        dropdown_link: 'https://help.flowcode.com/enterprise/en/',
        subsection: 'Support',
        badge: null
      },
      {
        link_title: 'Careers',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/company/careers',
        subsection: 'Connect',
        badge: null
      },
      {
        link_title: 'Our team',
        link_subtext: '',
        dropdown_link: 'https://www.flowcode.com/company/team',
        subsection: 'Connect',
        badge: null
      }
    ]
  },
  {
    primary: {
      header: 'Pricing',
      header_link: 'https://www.flowcode.com/enterprise-pricing'
    },
    items: []
  }
]
